import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'me-teaser-layout',
  styleUrl: 'me-teaser-layout.scss',
  shadow: false,
})
export class MeTeaserLayout {

  render() {
    return (
      <Host class="me-teaser-layout">
        <slot></slot>
      </Host>
    );
  }

}
